/*
 * File: cell-void.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-23 11:19:29
 * Modified By: Val Liu
 * -----
 */

import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";
import { CreateElement } from "vue";
import { Component } from "vue-property-decorator";

/// iv-cell-void: a hidden / non-submit field store anything.
/// used for a property that only provide meta.
@Component
@UITag.setDefault({
    uiHidden: true,
})
export default class CellVoid extends BaseTableBodyCell {
    render(h: CreateElement) {
        return this.$slots.default;
    }
}
